<template>
  <v-container id="dashboard-view" fluid tag="section">
    <default-loader-page v-if="loading" />
    
    <v-row>
      <v-col cols="12">
        <default-stats-top-card :stats="currentYearStats" :title="statTitle" />
      </v-col>
      <v-col cols="12">
        <default-stats-top-card
          :stats="stats[2]"
          title="КОЛИЧЕСТВО НЕФТЯНЫХ ОРГАНИЗАЦИЙ"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12"> <default-map-container /></v-col>
      <v-col cols="12"> <default-chart-container /></v-col>
    </v-row>
  </v-container>
</template>

<script>
import { get } from "vuex-pathify";

export default {
  name: "DashboardView",
  components: {
    DefaultMapContainer: () => import("@/components/map/MapContainer.vue"),
    DefaultChartContainer: () =>
      import("@/components/chart/ChartContainer.vue"),
    DefaultStatsTopCard: () => import("@/views/Dashboard/StatsTopCard.vue"),
    DefaultLoaderPage: () => import("@/components/LoaderPage.vue"),
    
  },

  computed: {
    stats: get("stats/stats")
  },
  data() {
    return {
      loading: true,
      currentYearStats: [],
      unit: " т.",
      statTitle: `ОБЩИЙ ОБОРОТ НЕФТИ И ГАЗА ЗА ${new Date().getFullYear()} ГОД`
    };
  },
  methods: {
    async initialize() {
      const url = "api/stat";
      const currentYearStatsValues = [];



      const { data } = await this.$http.get(url);
      const values = data.data || data;

      currentYearStatsValues.push(
        // Добыча нефти — фиксированное значение, не из API
        36142648,                                        // Добыча нефти
        values.refinery != null ? values.refinery : 0,   // Переработка нефти
        values.export != null ? values.export : 0,       // Экспорт нефти
        values.gas != null ? values.gas : 0              // Добыча газа
      );

      this.currentYearStats = this.stats[1].map((element, index) => {
        const unit = index === 3 ? " м³" : this.unit;
        const raw = currentYearStatsValues[index];
        element.value = (raw != null ? raw : 0).toLocaleString() + unit;
        return element;
      });
      this.loading = false;
    }
  },
  async created() {
    await this.initialize();
  }
};
</script>
